import axios, { AxiosInstance } from "axios";
import Spinner from "components/Spinner";
import React from "react";
import ReactDOM from "react-dom";
import config from '../config';
import AutoPostModel from "../models/auto-post.model";
import { FormCredential } from "../models/form-credential";
import { ResponseLogin } from "../models/response-login";
import SelectOfficeRequestModel from "../models/select-office-request.model";
import SelectOfficeResponseModel from "../models/select-office-response.model";

export default class AuthenticationApi {
    private _http: AxiosInstance;
    constructor() {
        this._http = axios.create({
            baseURL: config.API_BASE_URL,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json; charset=utf-8",
                "Access-Control-Allow-Credentials": true,
                "X-Requested-With": "XMLHttpRequest",
            },
            withCredentials: true,
        });
    }

    authenticateWithItsme(state: string, sp: string): Promise<ResponseLogin> {
        const data = { state, sp };
        return this._http
            .post<ResponseLogin>("authentication/itsme", data)
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    authenticateWithForm(credential: FormCredential): Promise<ResponseLogin> {
        return this._http
            .post<ResponseLogin>("authentication/form", credential)
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    selectOfficeSubOffice(selectOfficeRequest: SelectOfficeRequestModel): Promise<SelectOfficeResponseModel> {
        return this._http
            .post<SelectOfficeResponseModel>("authentication/selectOffice", selectOfficeRequest)
            .then((response) => response.data)
            .catch((error) => {
                throw error;
            });
    }

    autoPost(autoPost: AutoPostModel): void {
        ReactDOM.render(
            <form name="autopostForm" action={autoPost.acs} method="post">
                <Spinner isLoading />
                <input type="hidden" name="sp" value={autoPost.sp} />
                <input type="hidden" name="SAMLart" value={autoPost.token} />
            </form>,
            document.getElementById("root"),
            (window.onload = () => {
                document.forms[0].submit();
            }),
        );
    }
}
